"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FindPanelUserServiceContracts = exports.FindTeachUserServiceContracts = exports.FindStudyUserServiceContracts = exports.FindUserServiceContractsById = exports.FindUserServiceContractsFilter = exports.FindUserServiceContractsStrategyEnum = void 0;
var lodash_1 = require("lodash");
/** Алгоритмы поиска контрактов на услуги */
var FindUserServiceContractsStrategyEnum;
(function (FindUserServiceContractsStrategyEnum) {
  /**
   * Алгоритм поиска контрактов по ID
   *
   * @see FindUserServiceContractsById
   * */
  FindUserServiceContractsStrategyEnum["by_id"] = "by_id";
  /**
   * Алгоритм поиска контрактов, в которых указанный пользователь является учеником
   *
   * @see FindStudyUserServiceContracts
   * */
  FindUserServiceContractsStrategyEnum["study"] = "study";
  /**
   * Алгоритм поиска контрактов, в которых указанный пользователь является преподавателем
   *
   * @see FindTeachUserServiceContracts
   * */
  FindUserServiceContractsStrategyEnum["teach"] = "teach";
  /**
   * Алгоритм поиска контрактов для панели администратора
   *
   * @see FindPanelUserServiceContracts
   * */
  FindUserServiceContractsStrategyEnum["panel"] = "panel";
})(FindUserServiceContractsStrategyEnum = exports.FindUserServiceContractsStrategyEnum || (exports.FindUserServiceContractsStrategyEnum = {}));
var FindUserServiceContractsFilter = /** @class */function () {
  function FindUserServiceContractsFilter() {}
  return FindUserServiceContractsFilter;
}();
exports.FindUserServiceContractsFilter = FindUserServiceContractsFilter;
/** Параметры поиска контрактов на услуги по указанному списку id */
var FindUserServiceContractsById = /** @class */function (_super) {
  __extends(FindUserServiceContractsById, _super);
  function FindUserServiceContractsById(values) {
    var _this = _super.call(this) || this;
    _this.use = FindUserServiceContractsStrategyEnum.by_id;
    if (!values) {
      return _this;
    }
    _this.id = values.id;
    return _this;
  }
  return FindUserServiceContractsById;
}(FindUserServiceContractsFilter);
exports.FindUserServiceContractsById = FindUserServiceContractsById;
/** Параметры поиска контрактов, в которых указанный пользователь является учеником */
var FindStudyUserServiceContracts = /** @class */function (_super) {
  __extends(FindStudyUserServiceContracts, _super);
  function FindStudyUserServiceContracts(values) {
    var _this = _super.call(this) || this;
    _this.use = FindUserServiceContractsStrategyEnum.study;
    _this.type = 'any';
    if (!values) {
      return _this;
    }
    (0, lodash_1.assign)(_this, (0, lodash_1.pick)(values, ['account_id', 'contract_status', 'contractor_status', 'user_service_id', 'school_id', 'type']));
    return _this;
  }
  return FindStudyUserServiceContracts;
}(FindUserServiceContractsFilter);
exports.FindStudyUserServiceContracts = FindStudyUserServiceContracts;
/** Параметры поиска контрактов, в которых указанный пользователь является преподавателем */
var FindTeachUserServiceContracts = /** @class */function (_super) {
  __extends(FindTeachUserServiceContracts, _super);
  function FindTeachUserServiceContracts(values) {
    var _this = _super.call(this) || this;
    _this.use = FindUserServiceContractsStrategyEnum.teach;
    if (!values) {
      return _this;
    }
    (0, lodash_1.assign)(_this, (0, lodash_1.pick)(values, ['account_id', 'contract_status', 'user_service_id', 'school_id']));
    return _this;
  }
  return FindTeachUserServiceContracts;
}(FindUserServiceContractsFilter);
exports.FindTeachUserServiceContracts = FindTeachUserServiceContracts;
/** Параметры поиска контрактов для панели управления */
var FindPanelUserServiceContracts = /** @class */function (_super) {
  __extends(FindPanelUserServiceContracts, _super);
  function FindPanelUserServiceContracts(values) {
    var _this = _super.call(this) || this;
    _this.use = FindUserServiceContractsStrategyEnum.panel;
    if (!values) {
      return _this;
    }
    (0, lodash_1.assign)(_this, (0, lodash_1.pick)(values, ['user_id', 'contract_status', 'user_service_id', 'school_id']));
    return _this;
  }
  return FindPanelUserServiceContracts;
}(FindUserServiceContractsFilter);
exports.FindPanelUserServiceContracts = FindPanelUserServiceContracts;
